import React from "react";
import {
  Alert,
  AlertTitle,
  Button,
  Snackbar,
  Box,
  Typography,
  IconButton,
  Fade,
  LinearProgress
} from "@mui/material";
import {
  SystemUpdate as UpdateIcon,
  Close as CloseIcon,
  Refresh as RefreshIcon
} from "@mui/icons-material";

const UpdateBanner = ({ open, onUpdate, onDismiss, isUpdating }) => {
  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      TransitionComponent={Fade}
      sx={{
        zIndex: 9999,
        "& .MuiSnackbarContent-root": {
          borderRadius: "12px",
          boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
        }
      }}
    >
      <Alert
        severity="info"
        variant="filled"
        sx={{
          minWidth: { xs: "90vw", sm: "400px", md: "500px" },
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          color: "white",
          "& .MuiAlert-icon": {
            color: "white",
          },
          position: "relative"
        }}
        action={
          <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
            <Button
              variant="contained"
              size="small"
              onClick={onUpdate}
              disabled={isUpdating}
              startIcon={isUpdating ? <RefreshIcon /> : <UpdateIcon />}
              sx={{
                backgroundColor: "rgba(255,255,255,0.2)",
                color: "white",
                border: "1px solid rgba(255,255,255,0.3)",
                "&:hover": {
                  backgroundColor: "rgba(255,255,255,0.3)",
                },
                "&.Mui-disabled": {
                  backgroundColor: "rgba(255,255,255,0.1)",
                  color: "rgba(255,255,255,0.5)",
                }
              }}
            >
              {isUpdating ? "Se actualizează..." : "Actualizează"}
            </Button>
            <IconButton
              size="small"
              onClick={onDismiss}
              sx={{
                color: "white",
                opacity: 0.8,
                "&:hover": {
                  opacity: 1,
                  backgroundColor: "rgba(255,255,255,0.1)"
                }
              }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
        }
      >
        <AlertTitle sx={{
          fontWeight: "bold",
          mb: 0.5,
          display: "flex",
          alignItems: "center",
          gap: 1
        }}>
          <UpdateIcon fontSize="small" />
          Versiune nouă disponibilă!
        </AlertTitle>
        <Typography variant="body2" sx={{ mb: 1 }}>
          O nouă versiune a aplicației InBusiness este disponibilă.
          Actualizați pentru a beneficia de ultimele funcționalități și îmbunătățiri.
        </Typography>

        {isUpdating && (
          <Box sx={{ mt: 1 }}>
            <LinearProgress
              sx={{
                backgroundColor: "rgba(255,255,255,0.2)",
                "& .MuiLinearProgress-bar": {
                  backgroundColor: "white",
                }
              }}
            />
          </Box>
        )}
      </Alert>
    </Snackbar>
  );
};

export default UpdateBanner;